import React from "react";
import { useVideo } from "../features/permits/hooks/useVideo";
import { Progress } from "semantic-ui-react";
import mimetypes from "mime-types";
import { VideoStatus } from "../queries/files";

export function VideoPlayer({ uuid }: { uuid: string }) {
  const { url, status, isLoading, progress } = useVideo(uuid, 1000);

  if (isLoading) {
    return (
      <div className='ui placeholder segment'>
        <div className='ui active centered inline loader'></div>
      </div>
    );
  }

  if (status === VideoStatus.Pending || status === VideoStatus.Running) {
    return (
      <div className='ui placeholder segment tw-flex tw-min-h-[22rem] tw-min-w-[40rem] tw-items-center tw-rounded-3xl tw-bg-[#202020] tw-align-middle'>
        <Progress percent={progress || 0} indicating progress inverted className='tw-m-0 tw-min-w-[95%]' />
        <label className='ui label tw-m-0 tw-bg-transparent tw-text-lg tw-text-white-mid'>Processing video...</label>
      </div>
    );
  }

  if (status === VideoStatus.Error) {
    return (
      <div className='ui placeholder segment tw-flex tw-min-h-[22rem] tw-min-w-[40rem] tw-items-center tw-rounded-3xl tw-bg-[#202020] tw-align-middle'>
        <label className='ui label tw-m-0 tw-bg-transparent tw-text-lg tw-text-white-mid'>
          Video processing failed. Please try again.
        </label>
      </div>
    );
  }

  if (status === VideoStatus.Complete && url) {
    return (
      <video className='tw-h-auto tw-max-h-screen tw-w-full tw-rounded-3xl tw-p-4' controls>
        <source src={url} type={mimetypes.lookup("mp4") || ""} />
        <track kind='captions' />
        Your browser cannot play this video.
      </video>
    );
  }

  return (
    <div className='ui placeholder segment tw-flex tw-min-h-[22rem] tw-min-w-[40rem] tw-items-center tw-rounded-3xl tw-bg-[#202020] tw-align-middle'>
      <label className='ui label tw-m-0 tw-bg-transparent tw-text-lg tw-text-white-mid'>
        Video player failed to load.
      </label>
    </div>
  );
}
